import styled, { css } from 'styled-components';

const imageCss = css`
  background-image: url(${({ image }) => image});
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: solid 1px rgba(0, 0, 0, 0.06);

  .image {
    width: 55px;
    height: 55px;
    border-radius: 50%;
    background-position: center;
    background-size: cover;
    margin-right: 20px;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1), 0 2px 2px rgba(0, 0, 0, 0.1),
      0 4px 4px rgba(0, 0, 0, 0.1), 0 6px 8px rgba(0, 0, 0, 0.1),
      0 8px 16px rgba(0, 0, 0, 0.1);
    ${({ image }) => image && imageCss}
  }

  .info-container {
    .date {
      margin-top: 8px;
      display: flex;
      align-items: center;

      svg {
        margin-right: 8px;
      }

      span {
        font-size: 13px;
      }
    }

    .details {
      cursor: pointer;
      h3 {
        margin: 0 0 3px 0;
        padding-bottom: 5px;
        font-size: 0.85rem;
        font-weight: 600;
        border-bottom: solid 1px rgb(0, 0, 0, 0.05);
      }

      span {
        font-size: 0.74rem;
        font-weight: 300;
      }
    }
  }
`;
